"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../../helpers");

var _globalStyledComponents = require("../../globalStyledComponents");

var _helpers2 = require("../SupplierRow/helpers");

var _ATCButton = _interopRequireDefault(require("../ATCButton"));

var _styles = _interopRequireDefault(require("./styles"));

var _lodash = _interopRequireDefault(require("lodash"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var ItemContainer = _styles["default"].ItemContainer;

var handleItemClick = function handleItemClick(_ref) {
  var config = _ref.config,
      item = _ref.item,
      env = _ref.env,
      setCurItem = _ref.setCurItem,
      supplier = _ref.supplier;
  // postAnalytics(
  //     'item-selected-view',
  //     {
  //         store: config.title,
  //         item,
  //         url: item.Url,
  //     },
  //     env,
  // );
  setCurItem(_objectSpread(_objectSpread({}, item), {}, {
    supplier: supplier
  }));
};

var ItemCard = function ItemCard(props) {
  var mobile = props.mobile,
      item = props.item,
      loading = props.loading,
      config = props.config,
      index = props.index,
      contractId = props.contractId,
      supplier = props.supplier,
      env = props.env,
      setCurItem = props.setCurItem,
      _props$atcButton = props.atcButton,
      atcButton = _props$atcButton === void 0 ? true : _props$atcButton,
      _props$tags = props.tags,
      tags = _props$tags === void 0 ? true : _props$tags,
      supplierLogo = props.supplierLogo;

  if (loading) {
    return /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Card, {
      className: "loading-card fade-in",
      height: mobile && '7.5rem',
      width: mobile && '15rem',
      loading: loading.toString(),
      "data-aurora-automation": "store-item-card"
    }, /*#__PURE__*/_react["default"].createElement(ItemContainer, {
      loading: loading.toString(),
      index: index
    }, /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Row, null, /*#__PURE__*/_react["default"].createElement("div", {
      className: "img-container shine"
    }), /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Column, {
      className: "name-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "row1 shine"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row1 shine"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "row2 shine"
    }))), /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Row, {
      className: "availability-container shine"
    }), /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Row, {
      className: "price-atc-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-container shine"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "atc-container shine"
    })), /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Row, {
      className: "tags-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "tag shine"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "tag shine"
    }))));
  } else {
    return /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Card, {
      className: "card fade-in",
      height: mobile && '7.5rem',
      width: mobile && '15rem',
      "data-aurora-automation": "store-item-card",
      inheritHeight: true
    }, /*#__PURE__*/_react["default"].createElement(ItemContainer, null, /*#__PURE__*/_react["default"].createElement("a", {
      className: "link-wrapper",
      target: "_blank",
      onClick: function onClick() {
        return handleItemClick({
          config: config,
          item: item,
          env: env,
          setCurItem: setCurItem,
          supplier: supplier
        });
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "item-header",
      "data-aurora-automation": "store-item-header"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "item-image",
      src: item.Image.replace('&#x3D;', '='),
      className: "fade-in",
      "data-aurora-automation": "store-item-image"
    }), /*#__PURE__*/_react["default"].createElement(_globalStyledComponents.Column, null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "item-name",
      "data-aurora-automation": "store-item-name"
    }, item.Name), mobile && /*#__PURE__*/_react["default"].createElement("div", {
      className: "item-price",
      "data-aurora-automation": "store-item-price"
    }, (0, _helpers2.parsePrice)(item.Price))))), /*#__PURE__*/_react["default"].createElement("p", {
      className: "item-availability",
      "data-aurora-automation": "store-item-availability"
    }, item.Availability), !mobile && /*#__PURE__*/_react["default"].createElement("div", {
      className: "price-container"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "item-price",
      "data-aurora-automation": "store-item-price"
    }, (0, _helpers2.parsePrice)(item.Price)), atcButton && item.IsAvailable && /*#__PURE__*/_react["default"].createElement(_ATCButton["default"], {
      item: item,
      config: config,
      contractId: contractId,
      env: env
    }), supplierLogo && /*#__PURE__*/_react["default"].createElement("img", {
      className: "supplier-wide-logo",
      alt: "supplier-wide-logo",
      src: env.blobUrl + '/' + supplier.WideLogo
    })), tags && /*#__PURE__*/_react["default"].createElement("div", {
      className: "tags-container",
      "data-aurora-automation": "store-item-tags"
    }, item.IsAvailable && /*#__PURE__*/_react["default"].createElement("p", {
      className: "tag available"
    }, "Available"), !_lodash["default"].isNil(item.Attributes) && item.Attributes.map(function (attribute, i) {
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "tag",
        key: i
      }, attribute.Label);
    }))));
  }
};

var _default = ItemCard;
exports["default"] = _default;